import { ICompanyVideo, IGalleryImage } from "./GalleryModal.interface";

export const getUrlFromMediaObject = (mediaItemObj: IGalleryImage | ICompanyVideo) => {
  /** present on uploaded image/video */
  const FILE_URL = mediaItemObj?.file?.fileUrl || ""; 
  /** present on video with only URL that has been typed/pasted by user */
  const VIDEO_URL = (mediaItemObj as ICompanyVideo)?.videoUrl || ""; 
  const MEDIA_URL = FILE_URL || VIDEO_URL || "";
  return MEDIA_URL;
};